(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('ProfessionalAreaDeleteController',ProfessionalAreaDeleteController);

    ProfessionalAreaDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProfessionalArea'];

    function ProfessionalAreaDeleteController($uibModalInstance, entity, ProfessionalArea) {
        var vm = this;

        vm.professionalArea = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProfessionalArea.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
